// configService.js

// 1) Define your default config for local dev
const defaultConfig = {
  apiBaseUrl: "https://api.dev.paircare.ai",
  idmUrl: "https://idm.dev.paircare.ai",
  realm: "selfcare",
  clientId: "selfcare",
  imageBaseUrl: "https://dev0pairselfcarestorage.blob.core.windows.net/images/",
  localhostApi: false,
  promoMailDomain: "promo.dev.paircare.ai",
  newsMailDomain: "news.dev.paircare.ai",
  turnstileSiteKey: "1x00000000000000000000AA"
};

// 2) Keep a global reference to the current config
let globalConfig = defaultConfig;

// 3) Export a setter/getter for that config
export function setConfig(newConfig) {
  globalConfig = newConfig;
}

export function getConfig() {
  return globalConfig;
}

export function getDefaultConfig() {
  return defaultConfig;
}
